module.exports = __webpack_public_path__ + "media/images/channels/neurology-8a62926d128b6f6e4ac887686f596033.jpg";